(function () {
  function updateHeaderGroupHeight() {
    var sections = document.querySelectorAll('.shopify-section-group-header-group');
    if (!sections.length) return;

    var bottom = 0;
    sections.forEach(function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.bottom > bottom) bottom = rect.bottom;
    });

    if (bottom > 0) {
      document.documentElement.style.setProperty('--header-group-height', Math.round(bottom) + 'px');
    }
  }

  document.addEventListener('DOMContentLoaded', updateHeaderGroupHeight);
  window.addEventListener('load', updateHeaderGroupHeight);
  window.addEventListener('resize', updateHeaderGroupHeight);
  window.addEventListener('shopify:section:load', updateHeaderGroupHeight);
})();
